import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getSearch } from "../../../../api/repositories";
import { setInvalidToken } from "../../../../redux/features/main/invalidTokenSlice";
import { dataSearchAll } from "../constant";

const useActions = () => {
  const dispatch = useDispatch();
  const searchBarPosition = useSelector(
    (state) => state.search.searchBarPosition,
  );
  let [searchParams, setSearchParams] = useSearchParams();

  const [loadingAnchorSearch, setLoadingAnchorSearch] = useState(true);
  const [dataAcademySearch, setDataAcademySearch] = useState([]);
  const [dataProgramSearch, setDataProgramSearch] = useState([]);
  const [dataCourseSearch, setDataCourseSearch] = useState([]);
  const [dataModuleSearch, setDataModuleSearch] = useState([]);
  const [lengthData, setLengthData] = useState({
    academy: null,
    program: null,
    course: null,
    module: null,
  });

  const fetchSearch = async () => {
    setLoadingAnchorSearch(true);

    const typeParam =
      searchBarPosition !== ""
        ? searchBarPosition === "search_mylj"
          ? ""
          : "academy"
        : "";
    const paramSearch = `?type=${typeParam}&keyword=${searchParams.get(
      "search",
    )}`;

    try {
      const { data, status } = await getSearch(paramSearch);
      dispatch(setInvalidToken(status));
      // const { data } = dataSearchAll;
      getProgramList(data.program);
      getCourseList(data.course);
      getModuleList(data.module_essential, data.module_support);

      if (typeParam === "academy") getAcademyList(data.academy);
    } catch (err) {
      console.log("Error Fetch Search ", err);
      setDataAcademySearch([]);
      setDataProgramSearch([]);
      setDataCourseSearch([]);
      setDataModuleSearch([]);
      setLoadingAnchorSearch(false);
    } finally {
      setLoadingAnchorSearch(false);
    }
  };

  const getAcademyList = (data) => {
    const academyList = data.slice(0, 5);

    setLengthData((prevState) => {
      return {
        ...prevState,
        academy: data.length,
      };
    });

    setDataAcademySearch([...academyList]);
  };

  const getProgramList = (data) => {
    const programList = data.slice(0, 5);

    setLengthData((prevState) => {
      return {
        ...prevState,
        program: data.length,
      };
    });
    setDataProgramSearch([...programList]);
  };

  const getCourseList = (data) => {
    const courseList = data.slice(0, 5);

    setLengthData((prevState) => {
      return {
        ...prevState,
        course: data.length,
      };
    });
    setDataCourseSearch([...courseList]);
  };

  const getModuleList = (essential, support) => {
    const moduleEs = [].concat(
      ...essential.map((item) => {
        item.isEss = 1;
        return item;
      }),
    );

    const moduleSup = [].concat(
      ...support.map((item) => {
        item.isEss = 0;
        return item;
      }),
    );

    const concatAll = moduleEs.concat(moduleSup);

    const moduleList = concatAll.slice(0, 5);

    setLengthData((prevState) => {
      return {
        ...prevState,
        module: concatAll.length,
      };
    });
    setDataModuleSearch([...moduleList]);
  };

  useEffect(() => {
    if (
      searchParams.get("search") !== undefined &&
      searchParams.get("search") !== "" &&
      searchParams.get("search") !== null
    ) {
      fetchSearch();
    }
  }, [searchParams]);

  return {
    dataAcademySearch,
    dataProgramSearch,
    dataCourseSearch,
    dataModuleSearch,
    lengthData,
    loadingAnchorSearch,
  };
};

export default useActions;
